module.exports = __webpack_public_path__ + "media/educators/printedMaterialsrow620x151-transp-33e195d2.png";